import Api from '@teko/api';
import { jwtDecode } from './jwt.es.js';
import { accessTokenInterceptor } from './interceptor.es.js';
import { userManager } from './user.es.js';
import tekoOAuth from 'teko-oauth2';
import { logger } from '@teko/log';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
let tekoOAuthPromise = null;
const IAM_ERRORS_MAP = {
  "1019": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c",
  "1020": "\u0110\u1ECBa ch\u1EC9 email \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c.",
  "1040": "M\xE3 OTP kh\xF4ng ch\xEDnh x\xE1c",
  "1015": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7",
  "1800": "\u0110\xE3 g\u1EEDi qu\xE1 nhi\u1EC1u y\xEAu c\u1EA7u, vui l\xF2ng quay l\u1EA1i sau"
};
class AuthService {
  constructor(iamUrl, iamClientId, iamOauthDomain) {
    this.initialize = async (scopes) => {
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        if (!tekoOAuthPromise) {
          tekoOAuthPromise = tekoOAuth.init({
            clientId: this.iamClientId,
            scopes,
            oauthDomain: this.iamOauthDomain
          });
        }
        return tekoOAuthPromise.then(() => {
          tekoOAuthPromise = null;
        }).catch((error) => {
          logger.error(error);
          tekoOAuthPromise = null;
        });
      } else {
        return Promise.resolve();
      }
    };
    this.requestLogin = async (challenge) => {
      try {
        const { data } = await this.authApi.get(`/v1/requests/login/${challenge}`, {});
        return data;
      } catch (er) {
        logger.error(er);
        if (typeof window !== "undefined")
          window.location.href = "/";
      }
    };
    this.login = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.login(redirectUrl || (window.location.pathname === "/" ? void 0 : window.location.href));
    };
    this.logout = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.logout(redirectUrl);
      userManager.onLoggedOut();
    };
    this.requestLogout = async (challenge) => {
      const {
        data: { redirect_to: redirectTo }
      } = await this.authApi.post(`/v1/requests/logout/${challenge}`, {
        challenge,
        confirmed: true
      });
      userManager.onLoggedOut();
      if (redirectTo)
        window.location.assign(redirectTo);
    };
    this.loginSocialIAM = async (challenge, accessToken, authorizer) => {
      return await this.authApi.post("/v1/social/login", {
        challenge,
        access_token: accessToken,
        authorizer
      });
    };
    this.sendOTP = async (challenge, phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/passwordless/send", __spreadValues({
        challenge,
        phone_number: phone,
        client_id: this.iamClientId
      }, recaptchaToken && { recaptcha_token: recaptchaToken }));
      return data;
    };
    this.sendOTPUpdatePhone = async (phone) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", {
        phone_number: phone
      });
      return data;
    };
    this.register = async (phone, name) => {
      const { data } = await this.authApi.post(`/v1/users/register`, {
        username: phone,
        password: Math.random().toString(36).slice(-16),
        name
      });
      return data;
    };
    this.loginIAMWithPhone = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/passwordless/login", {
        challenge,
        phone_number: phone,
        code: otp
      });
      return data;
    };
    this.activeIAMPhoneAccount = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/users/confirm", {
        challenge,
        username: phone,
        code: otp
      });
      return data;
    };
    this.resendOTP = async (phone, mode, challenge = "", recaptchaToken) => {
      if (mode === "login")
        return await this.sendOTP(challenge, phone, recaptchaToken);
      const { data } = await this.authApi.post("/v1/users/activation/resend", {
        username: phone
      });
      return data;
    };
    this.refreshToken = async (refreshToken) => {
      const queries = `grant_type=refresh_token&client_id=${this.iamClientId}&refresh_token=${refreshToken}`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      userManager.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithFederation = async (idToken, authorizer) => {
      const queries = `grant_type=federated_idp&client_id=${this.iamClientId}&jwt_token=${idToken}&authorizer=${authorizer}&scope=openid profile read:permissions us ps ppm om`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      userManager.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithIBanking = async (data) => {
      const { partner_code } = data;
      let queries = `grant_type=ibanking&client_id=${this.iamClientId}&data=${data.data}&signature=${data.signature}&scope=openid profile read:permissions us ps ppm om`;
      if (partner_code) {
        queries = `${queries}&partner_code=${partner_code}`;
      }
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      const { ibanking_info } = responseData;
      userManager.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub,
        bankCode: ibanking_info == null ? void 0 : ibanking_info.bankcode,
        phone: ibanking_info == null ? void 0 : ibanking_info.mobile
      });
      return responseData;
    };
    this.loginWithTerra = (loginInfo) => {
      userManager.onPartnerLoggedIn({
        userId: loginInfo.userId,
        name: loginInfo.name,
        accessToken: loginInfo.accessToken,
        phone: loginInfo.phone,
        picture: loginInfo.picture,
        email: loginInfo.email
      });
      return userManager.getLSInfo();
    };
    this.getLoginInfo = () => {
      return userManager.getInfo();
    };
    this.isLoggedIn = () => {
      return !!userManager.getAccessToken();
    };
    this.verifyPhone = async (phoneNumber) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", {
        phone_number: phoneNumber
      });
      return data;
    };
    this.verifyEmail = async (email) => {
      const { data } = await this.authApi.post("/v1/me/email/verify", { email });
      return data;
    };
    this.updatePhone = async (phoneNumber, otp) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/update", {
        phone_number: phoneNumber,
        code: otp
      });
      return data;
    };
    this.updateEmail = async (email, otp) => {
      const { data } = await this.authApi.post("/v1/me/email/update", {
        email,
        code: otp
      });
      return data;
    };
    this.errorMsg = (err) => {
      var _a;
      const errorCode = typeof err === "string" ? err : (_a = err == null ? void 0 : err.error) == null ? void 0 : _a.code;
      return IAM_ERRORS_MAP[errorCode];
    };
    this.iamUrl = iamUrl;
    this.iamClientId = iamClientId;
    this.iamOauthDomain = iamOauthDomain;
    this.authApi = new Api(iamUrl);
    this.authApi.addInterceptor(accessTokenInterceptor);
  }
  get tekoID() {
    return window.TekoID;
  }
}

export { AuthService };
